import { DropzoneField } from '@lfg/ui/components';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import { Box, Grid2, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';

import { AdminNumberFormat } from 'src/components/NodeSaleForm/AdminNumberFormat';
import { ColorPicker } from 'src/components/NodeSaleForm/ColorPicker';
import { colors } from 'src/global/styles/colors';
import { useTheme } from 'src/provider/ThemeCustomizationProvider';

import { SectionAccordion } from './SectionAccordion';

export function ThemeBackground() {
  const { theme, updateTheme } = useTheme();
  const imageOpacity = useMemo(() => {
    return theme.theme.background.imageOpacity ? theme.theme.background.imageOpacity * 100 : undefined;
  }, [theme.theme.background.imageOpacity]);

  return (
    <Box padding={'12px 24px 24px 24px'} borderBottom={`1px solid ${colors.neutral015}`}>
      <SectionAccordion
        title='Background'
        bodyContent={
          <Box width={'100%'}>
            <Grid2 container width={'100%'} spacing={3}>
              <Grid2 size={6}>
                <Typography fontSize={'14px'} fontWeight={500} lineHeight={'20px'} sx={{ color: 'white' }}>
                  Fill Color
                </Typography>
                <Typography
                  marginTop={1}
                  fontSize={'12px'}
                  fontWeight={400}
                  lineHeight={'16px'}
                  sx={{ color: colors.neutral90 }}></Typography>
                <Box width={'100%'} marginTop={2}>
                  <ColorPicker
                    color={theme.theme.background.color}
                    onColorChange={color => {
                      updateTheme({
                        ...theme,
                        theme: { ...theme.theme, background: { ...theme.theme.background, color: color } },
                      });
                    }}
                    opacity={theme.theme.background.colorOpacity}
                    onOpacityChange={opacity => {
                      updateTheme({
                        ...theme,
                        theme: {
                          ...theme.theme,
                          background: { ...theme.theme.background, colorOpacity: opacity / 100 },
                        },
                      });
                    }}
                  />
                </Box>
              </Grid2>
              <Grid2 size={6}>
                <Typography fontSize={'14px'} fontWeight={500} lineHeight={'20px'} sx={{ color: 'white' }}>
                  Image (Optional)
                </Typography>
                <Box width={'100%'} marginTop={2}>
                  <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={1}>
                    <Box width={'70%'}>
                      <DropzoneField
                        maxFiles={1}
                        containerSx={{
                          border: `1px solid ${colors.neutral015}`,
                          borderRadius: '4px',
                          height: '54px',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                        iconWrapperStyle={{
                          top: 0,
                          right: 0,
                        }}
                        onDrop={files => {
                          updateTheme({
                            ...theme,
                            theme: {
                              ...theme.theme,
                              background: {
                                ...theme.theme.background,
                                image: files[0],
                              },
                            },
                          });
                        }}
                        files={theme.theme.background.image ? [theme.theme.background.image] : []}
                        accept={{
                          'image/jpeg': [],
                          'image/png': [],
                          'image/svg+xml': [],
                          'image/jpg': [],
                        }}
                        emptyContent={<ImageSearchIcon sx={{ width: '24px', height: '24px', color: 'white' }} />}
                      />
                    </Box>
                    <Box width={'30%'}>
                      <AdminNumberFormat
                        isAllowed={values => {
                          const { floatValue } = values;
                          if (!floatValue) return true;
                          return floatValue >= 0 && floatValue <= 100;
                        }}
                        value={imageOpacity}
                        onValueChange={e => {
                          updateTheme({
                            ...theme,
                            theme: {
                              ...theme.theme,
                              background: {
                                ...theme.theme.background,
                                imageOpacity: (e.floatValue || 0) / 100,
                              },
                            },
                          });
                        }}
                        suffix='%'
                      />
                    </Box>
                  </Stack>
                </Box>
              </Grid2>
            </Grid2>
          </Box>
        }
      />
    </Box>
  );
}
